import { render, staticRenderFns } from "./CreateOtherService.vue?vue&type=template&id=33ec8fe0&"
import script from "./CreateOtherService.vue?vue&type=script&lang=ts&"
export * from "./CreateOtherService.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOtherService.vue?vue&type=style&index=0&id=33ec8fe0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports